/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './../../app/__root'
import { Route as Import } from './../../app/*'
import { Route as guestLayoutImport } from './../../app/(guest)/layout'
import { Route as authenticatedLayoutImport } from './../../app/(authenticated)/layout'
import { Route as authenticatedPageImport } from './../../app/(authenticated)/page'
import { Route as guestTwoFactorPageImport } from './../../app/(guest)/two-factor/page'
import { Route as guestSettingMfaPageImport } from './../../app/(guest)/setting-mfa/page'
import { Route as guestLoginPageImport } from './../../app/(guest)/login/page'
import { Route as guestForgotPasswordPageImport } from './../../app/(guest)/forgot-password/page'
import { Route as authenticatedSettingMfaPageImport } from './../../app/(authenticated)/setting/mfa/page'
import { Route as authenticatedSettingAccountPageImport } from './../../app/(authenticated)/setting/account/page'
import { Route as authenticatedMerchantIdVirtualTerminalPageImport } from './../../app/(authenticated)/$merchantId/virtual-terminal/page'
import { Route as authenticatedMerchantIdTransactionsPageImport } from './../../app/(authenticated)/$merchantId/transactions/page'
import { Route as authenticatedMerchantIdStockOrdersPageImport } from './../../app/(authenticated)/$merchantId/stock-orders/page'
import { Route as authenticatedMerchantIdRecursPageImport } from './../../app/(authenticated)/$merchantId/recurs/page'
import { Route as authenticatedMerchantIdProductsPageImport } from './../../app/(authenticated)/$merchantId/products/page'
import { Route as authenticatedMerchantIdPlansPageImport } from './../../app/(authenticated)/$merchantId/plans/page'
import { Route as authenticatedMerchantIdPackagesPageImport } from './../../app/(authenticated)/$merchantId/packages/page'
import { Route as authenticatedMerchantIdMerchantDefinedFieldsPageImport } from './../../app/(authenticated)/$merchantId/merchant-defined-fields/page'
import { Route as authenticatedMerchantIdLocationsPageImport } from './../../app/(authenticated)/$merchantId/locations/page'
import { Route as authenticatedMerchantIdInvoicesPageImport } from './../../app/(authenticated)/$merchantId/invoices/page'
import { Route as authenticatedMerchantIdCustomersPageImport } from './../../app/(authenticated)/$merchantId/customers/page'
import { Route as authenticatedMerchantIdCategoriesPageImport } from './../../app/(authenticated)/$merchantId/categories/page'
import { Route as authenticatedMerchantIdCustomersIdLayoutImport } from './../../app/(authenticated)/$merchantId/customers/$id/layout'
import { Route as guestForgotPasswordResetPasswordIdPageImport } from './../../app/(guest)/forgot-password/reset-password/$id/page'
import { Route as authenticatedMerchantIdTransactionsBatchPageImport } from './../../app/(authenticated)/$merchantId/transactions/batch/page'
import { Route as authenticatedMerchantIdStockOrdersAddPageImport } from './../../app/(authenticated)/$merchantId/stock-orders/add/page'
import { Route as authenticatedMerchantIdStockOrdersIdPageImport } from './../../app/(authenticated)/$merchantId/stock-orders/$id/page'
import { Route as authenticatedMerchantIdRecursAddPageImport } from './../../app/(authenticated)/$merchantId/recurs/add/page'
import { Route as authenticatedMerchantIdRecursIdPageImport } from './../../app/(authenticated)/$merchantId/recurs/$id/page'
import { Route as authenticatedMerchantIdProductsAddPageImport } from './../../app/(authenticated)/$merchantId/products/add/page'
import { Route as authenticatedMerchantIdProductsIdPageImport } from './../../app/(authenticated)/$merchantId/products/$id/page'
import { Route as authenticatedMerchantIdPlansAddPageImport } from './../../app/(authenticated)/$merchantId/plans/add/page'
import { Route as authenticatedMerchantIdPlansIdPageImport } from './../../app/(authenticated)/$merchantId/plans/$id/page'
import { Route as authenticatedMerchantIdPackagesAddPageImport } from './../../app/(authenticated)/$merchantId/packages/add/page'
import { Route as authenticatedMerchantIdPackagesIdPageImport } from './../../app/(authenticated)/$merchantId/packages/$id/page'
import { Route as authenticatedMerchantIdMerchantDefinedFieldsAddPageImport } from './../../app/(authenticated)/$merchantId/merchant-defined-fields/add/page'
import { Route as authenticatedMerchantIdInvoicesAddPageImport } from './../../app/(authenticated)/$merchantId/invoices/add/page'
import { Route as authenticatedMerchantIdInvoicesIdPageImport } from './../../app/(authenticated)/$merchantId/invoices/$id/page'
import { Route as authenticatedMerchantIdCustomersAddPageImport } from './../../app/(authenticated)/$merchantId/customers/add/page'
import { Route as authenticatedMerchantIdCustomersIdPageImport } from './../../app/(authenticated)/$merchantId/customers/$id/page'
import { Route as authenticatedMerchantIdTransactionsTabIdPageImport } from './../../app/(authenticated)/$merchantId/transactions/$tab/$id/page'
import { Route as authenticatedMerchantIdMerchantDefinedFieldsIdPreviewPageImport } from './../../app/(authenticated)/$merchantId/merchant-defined-fields/$id/preview/page'
import { Route as authenticatedMerchantIdMerchantDefinedFieldsIdEditPageImport } from './../../app/(authenticated)/$merchantId/merchant-defined-fields/$id/edit/page'
import { Route as authenticatedMerchantIdInvoicesIdTransactionPageImport } from './../../app/(authenticated)/$merchantId/invoices/$id/transaction/page'

// Create/Update Routes

const Route = Import.update({
  id: '/*',
  path: '/*',
  getParentRoute: () => rootRoute,
} as any)

const guestLayoutRoute = guestLayoutImport.update({
  id: '/(guest)',
  getParentRoute: () => rootRoute,
} as any)

const authenticatedLayoutRoute = authenticatedLayoutImport.update({
  id: '/(authenticated)',
  getParentRoute: () => rootRoute,
} as any)

const authenticatedPageRoute = authenticatedPageImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authenticatedLayoutRoute,
} as any)

const guestTwoFactorPageRoute = guestTwoFactorPageImport.update({
  id: '/two-factor/',
  path: '/two-factor/',
  getParentRoute: () => guestLayoutRoute,
} as any)

const guestSettingMfaPageRoute = guestSettingMfaPageImport.update({
  id: '/setting-mfa/',
  path: '/setting-mfa/',
  getParentRoute: () => guestLayoutRoute,
} as any)

const guestLoginPageRoute = guestLoginPageImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => guestLayoutRoute,
} as any)

const guestForgotPasswordPageRoute = guestForgotPasswordPageImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => guestLayoutRoute,
} as any)

const authenticatedSettingMfaPageRoute =
  authenticatedSettingMfaPageImport.update({
    id: '/setting/mfa/',
    path: '/setting/mfa/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedSettingAccountPageRoute =
  authenticatedSettingAccountPageImport.update({
    id: '/setting/account/',
    path: '/setting/account/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdVirtualTerminalPageRoute =
  authenticatedMerchantIdVirtualTerminalPageImport.update({
    id: '/$merchantId/virtual-terminal/',
    path: '/$merchantId/virtual-terminal/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdTransactionsPageRoute =
  authenticatedMerchantIdTransactionsPageImport.update({
    id: '/$merchantId/transactions/',
    path: '/$merchantId/transactions/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdStockOrdersPageRoute =
  authenticatedMerchantIdStockOrdersPageImport.update({
    id: '/$merchantId/stock-orders/',
    path: '/$merchantId/stock-orders/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdRecursPageRoute =
  authenticatedMerchantIdRecursPageImport.update({
    id: '/$merchantId/recurs/',
    path: '/$merchantId/recurs/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdProductsPageRoute =
  authenticatedMerchantIdProductsPageImport.update({
    id: '/$merchantId/products/',
    path: '/$merchantId/products/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdPlansPageRoute =
  authenticatedMerchantIdPlansPageImport.update({
    id: '/$merchantId/plans/',
    path: '/$merchantId/plans/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdPackagesPageRoute =
  authenticatedMerchantIdPackagesPageImport.update({
    id: '/$merchantId/packages/',
    path: '/$merchantId/packages/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdMerchantDefinedFieldsPageRoute =
  authenticatedMerchantIdMerchantDefinedFieldsPageImport.update({
    id: '/$merchantId/merchant-defined-fields/',
    path: '/$merchantId/merchant-defined-fields/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdLocationsPageRoute =
  authenticatedMerchantIdLocationsPageImport.update({
    id: '/$merchantId/locations/',
    path: '/$merchantId/locations/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdInvoicesPageRoute =
  authenticatedMerchantIdInvoicesPageImport.update({
    id: '/$merchantId/invoices/',
    path: '/$merchantId/invoices/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdCustomersPageRoute =
  authenticatedMerchantIdCustomersPageImport.update({
    id: '/$merchantId/customers/',
    path: '/$merchantId/customers/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdCategoriesPageRoute =
  authenticatedMerchantIdCategoriesPageImport.update({
    id: '/$merchantId/categories/',
    path: '/$merchantId/categories/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdCustomersIdLayoutRoute =
  authenticatedMerchantIdCustomersIdLayoutImport.update({
    id: '/$merchantId/customers/$id',
    path: '/$merchantId/customers/$id',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const guestForgotPasswordResetPasswordIdPageRoute =
  guestForgotPasswordResetPasswordIdPageImport.update({
    id: '/forgot-password/reset-password/$id/',
    path: '/forgot-password/reset-password/$id/',
    getParentRoute: () => guestLayoutRoute,
  } as any)

const authenticatedMerchantIdTransactionsBatchPageRoute =
  authenticatedMerchantIdTransactionsBatchPageImport.update({
    id: '/$merchantId/transactions/batch/',
    path: '/$merchantId/transactions/batch/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdStockOrdersAddPageRoute =
  authenticatedMerchantIdStockOrdersAddPageImport.update({
    id: '/$merchantId/stock-orders/add/',
    path: '/$merchantId/stock-orders/add/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdStockOrdersIdPageRoute =
  authenticatedMerchantIdStockOrdersIdPageImport.update({
    id: '/$merchantId/stock-orders/$id/',
    path: '/$merchantId/stock-orders/$id/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdRecursAddPageRoute =
  authenticatedMerchantIdRecursAddPageImport.update({
    id: '/$merchantId/recurs/add/',
    path: '/$merchantId/recurs/add/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdRecursIdPageRoute =
  authenticatedMerchantIdRecursIdPageImport.update({
    id: '/$merchantId/recurs/$id/',
    path: '/$merchantId/recurs/$id/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdProductsAddPageRoute =
  authenticatedMerchantIdProductsAddPageImport.update({
    id: '/$merchantId/products/add/',
    path: '/$merchantId/products/add/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdProductsIdPageRoute =
  authenticatedMerchantIdProductsIdPageImport.update({
    id: '/$merchantId/products/$id/',
    path: '/$merchantId/products/$id/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdPlansAddPageRoute =
  authenticatedMerchantIdPlansAddPageImport.update({
    id: '/$merchantId/plans/add/',
    path: '/$merchantId/plans/add/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdPlansIdPageRoute =
  authenticatedMerchantIdPlansIdPageImport.update({
    id: '/$merchantId/plans/$id/',
    path: '/$merchantId/plans/$id/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdPackagesAddPageRoute =
  authenticatedMerchantIdPackagesAddPageImport.update({
    id: '/$merchantId/packages/add/',
    path: '/$merchantId/packages/add/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdPackagesIdPageRoute =
  authenticatedMerchantIdPackagesIdPageImport.update({
    id: '/$merchantId/packages/$id/',
    path: '/$merchantId/packages/$id/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdMerchantDefinedFieldsAddPageRoute =
  authenticatedMerchantIdMerchantDefinedFieldsAddPageImport.update({
    id: '/$merchantId/merchant-defined-fields/add/',
    path: '/$merchantId/merchant-defined-fields/add/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdInvoicesAddPageRoute =
  authenticatedMerchantIdInvoicesAddPageImport.update({
    id: '/$merchantId/invoices/add/',
    path: '/$merchantId/invoices/add/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdInvoicesIdPageRoute =
  authenticatedMerchantIdInvoicesIdPageImport.update({
    id: '/$merchantId/invoices/$id/',
    path: '/$merchantId/invoices/$id/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdCustomersAddPageRoute =
  authenticatedMerchantIdCustomersAddPageImport.update({
    id: '/$merchantId/customers/add/',
    path: '/$merchantId/customers/add/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdCustomersIdPageRoute =
  authenticatedMerchantIdCustomersIdPageImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => authenticatedMerchantIdCustomersIdLayoutRoute,
  } as any)

const authenticatedMerchantIdTransactionsTabIdPageRoute =
  authenticatedMerchantIdTransactionsTabIdPageImport.update({
    id: '/$merchantId/transactions/$tab/$id/',
    path: '/$merchantId/transactions/$tab/$id/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdMerchantDefinedFieldsIdPreviewPageRoute =
  authenticatedMerchantIdMerchantDefinedFieldsIdPreviewPageImport.update({
    id: '/$merchantId/merchant-defined-fields/$id/preview/',
    path: '/$merchantId/merchant-defined-fields/$id/preview/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdMerchantDefinedFieldsIdEditPageRoute =
  authenticatedMerchantIdMerchantDefinedFieldsIdEditPageImport.update({
    id: '/$merchantId/merchant-defined-fields/$id/edit/',
    path: '/$merchantId/merchant-defined-fields/$id/edit/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

const authenticatedMerchantIdInvoicesIdTransactionPageRoute =
  authenticatedMerchantIdInvoicesIdTransactionPageImport.update({
    id: '/$merchantId/invoices/$id/transaction/',
    path: '/$merchantId/invoices/$id/transaction/',
    getParentRoute: () => authenticatedLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(authenticated)': {
      id: '/(authenticated)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authenticatedLayoutImport
      parentRoute: typeof rootRoute
    }
    '/(guest)': {
      id: '/(guest)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof guestLayoutImport
      parentRoute: typeof rootRoute
    }
    '/*': {
      id: '/*'
      path: '/*'
      fullPath: '/*'
      preLoaderRoute: typeof Import
      parentRoute: typeof rootRoute
    }
    '/(authenticated)/': {
      id: '/(authenticated)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authenticatedPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(guest)/forgot-password/': {
      id: '/(guest)/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof guestForgotPasswordPageImport
      parentRoute: typeof guestLayoutImport
    }
    '/(guest)/login/': {
      id: '/(guest)/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof guestLoginPageImport
      parentRoute: typeof guestLayoutImport
    }
    '/(guest)/setting-mfa/': {
      id: '/(guest)/setting-mfa/'
      path: '/setting-mfa'
      fullPath: '/setting-mfa'
      preLoaderRoute: typeof guestSettingMfaPageImport
      parentRoute: typeof guestLayoutImport
    }
    '/(guest)/two-factor/': {
      id: '/(guest)/two-factor/'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof guestTwoFactorPageImport
      parentRoute: typeof guestLayoutImport
    }
    '/(authenticated)/$merchantId/customers/$id': {
      id: '/(authenticated)/$merchantId/customers/$id'
      path: '/$merchantId/customers/$id'
      fullPath: '/$merchantId/customers/$id'
      preLoaderRoute: typeof authenticatedMerchantIdCustomersIdLayoutImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/categories/': {
      id: '/(authenticated)/$merchantId/categories/'
      path: '/$merchantId/categories'
      fullPath: '/$merchantId/categories'
      preLoaderRoute: typeof authenticatedMerchantIdCategoriesPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/customers/': {
      id: '/(authenticated)/$merchantId/customers/'
      path: '/$merchantId/customers'
      fullPath: '/$merchantId/customers'
      preLoaderRoute: typeof authenticatedMerchantIdCustomersPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/invoices/': {
      id: '/(authenticated)/$merchantId/invoices/'
      path: '/$merchantId/invoices'
      fullPath: '/$merchantId/invoices'
      preLoaderRoute: typeof authenticatedMerchantIdInvoicesPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/locations/': {
      id: '/(authenticated)/$merchantId/locations/'
      path: '/$merchantId/locations'
      fullPath: '/$merchantId/locations'
      preLoaderRoute: typeof authenticatedMerchantIdLocationsPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/merchant-defined-fields/': {
      id: '/(authenticated)/$merchantId/merchant-defined-fields/'
      path: '/$merchantId/merchant-defined-fields'
      fullPath: '/$merchantId/merchant-defined-fields'
      preLoaderRoute: typeof authenticatedMerchantIdMerchantDefinedFieldsPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/packages/': {
      id: '/(authenticated)/$merchantId/packages/'
      path: '/$merchantId/packages'
      fullPath: '/$merchantId/packages'
      preLoaderRoute: typeof authenticatedMerchantIdPackagesPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/plans/': {
      id: '/(authenticated)/$merchantId/plans/'
      path: '/$merchantId/plans'
      fullPath: '/$merchantId/plans'
      preLoaderRoute: typeof authenticatedMerchantIdPlansPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/products/': {
      id: '/(authenticated)/$merchantId/products/'
      path: '/$merchantId/products'
      fullPath: '/$merchantId/products'
      preLoaderRoute: typeof authenticatedMerchantIdProductsPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/recurs/': {
      id: '/(authenticated)/$merchantId/recurs/'
      path: '/$merchantId/recurs'
      fullPath: '/$merchantId/recurs'
      preLoaderRoute: typeof authenticatedMerchantIdRecursPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/stock-orders/': {
      id: '/(authenticated)/$merchantId/stock-orders/'
      path: '/$merchantId/stock-orders'
      fullPath: '/$merchantId/stock-orders'
      preLoaderRoute: typeof authenticatedMerchantIdStockOrdersPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/transactions/': {
      id: '/(authenticated)/$merchantId/transactions/'
      path: '/$merchantId/transactions'
      fullPath: '/$merchantId/transactions'
      preLoaderRoute: typeof authenticatedMerchantIdTransactionsPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/virtual-terminal/': {
      id: '/(authenticated)/$merchantId/virtual-terminal/'
      path: '/$merchantId/virtual-terminal'
      fullPath: '/$merchantId/virtual-terminal'
      preLoaderRoute: typeof authenticatedMerchantIdVirtualTerminalPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/setting/account/': {
      id: '/(authenticated)/setting/account/'
      path: '/setting/account'
      fullPath: '/setting/account'
      preLoaderRoute: typeof authenticatedSettingAccountPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/setting/mfa/': {
      id: '/(authenticated)/setting/mfa/'
      path: '/setting/mfa'
      fullPath: '/setting/mfa'
      preLoaderRoute: typeof authenticatedSettingMfaPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/customers/$id/': {
      id: '/(authenticated)/$merchantId/customers/$id/'
      path: '/'
      fullPath: '/$merchantId/customers/$id/'
      preLoaderRoute: typeof authenticatedMerchantIdCustomersIdPageImport
      parentRoute: typeof authenticatedMerchantIdCustomersIdLayoutImport
    }
    '/(authenticated)/$merchantId/customers/add/': {
      id: '/(authenticated)/$merchantId/customers/add/'
      path: '/$merchantId/customers/add'
      fullPath: '/$merchantId/customers/add'
      preLoaderRoute: typeof authenticatedMerchantIdCustomersAddPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/invoices/$id/': {
      id: '/(authenticated)/$merchantId/invoices/$id/'
      path: '/$merchantId/invoices/$id'
      fullPath: '/$merchantId/invoices/$id'
      preLoaderRoute: typeof authenticatedMerchantIdInvoicesIdPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/invoices/add/': {
      id: '/(authenticated)/$merchantId/invoices/add/'
      path: '/$merchantId/invoices/add'
      fullPath: '/$merchantId/invoices/add'
      preLoaderRoute: typeof authenticatedMerchantIdInvoicesAddPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/merchant-defined-fields/add/': {
      id: '/(authenticated)/$merchantId/merchant-defined-fields/add/'
      path: '/$merchantId/merchant-defined-fields/add'
      fullPath: '/$merchantId/merchant-defined-fields/add'
      preLoaderRoute: typeof authenticatedMerchantIdMerchantDefinedFieldsAddPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/packages/$id/': {
      id: '/(authenticated)/$merchantId/packages/$id/'
      path: '/$merchantId/packages/$id'
      fullPath: '/$merchantId/packages/$id'
      preLoaderRoute: typeof authenticatedMerchantIdPackagesIdPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/packages/add/': {
      id: '/(authenticated)/$merchantId/packages/add/'
      path: '/$merchantId/packages/add'
      fullPath: '/$merchantId/packages/add'
      preLoaderRoute: typeof authenticatedMerchantIdPackagesAddPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/plans/$id/': {
      id: '/(authenticated)/$merchantId/plans/$id/'
      path: '/$merchantId/plans/$id'
      fullPath: '/$merchantId/plans/$id'
      preLoaderRoute: typeof authenticatedMerchantIdPlansIdPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/plans/add/': {
      id: '/(authenticated)/$merchantId/plans/add/'
      path: '/$merchantId/plans/add'
      fullPath: '/$merchantId/plans/add'
      preLoaderRoute: typeof authenticatedMerchantIdPlansAddPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/products/$id/': {
      id: '/(authenticated)/$merchantId/products/$id/'
      path: '/$merchantId/products/$id'
      fullPath: '/$merchantId/products/$id'
      preLoaderRoute: typeof authenticatedMerchantIdProductsIdPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/products/add/': {
      id: '/(authenticated)/$merchantId/products/add/'
      path: '/$merchantId/products/add'
      fullPath: '/$merchantId/products/add'
      preLoaderRoute: typeof authenticatedMerchantIdProductsAddPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/recurs/$id/': {
      id: '/(authenticated)/$merchantId/recurs/$id/'
      path: '/$merchantId/recurs/$id'
      fullPath: '/$merchantId/recurs/$id'
      preLoaderRoute: typeof authenticatedMerchantIdRecursIdPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/recurs/add/': {
      id: '/(authenticated)/$merchantId/recurs/add/'
      path: '/$merchantId/recurs/add'
      fullPath: '/$merchantId/recurs/add'
      preLoaderRoute: typeof authenticatedMerchantIdRecursAddPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/stock-orders/$id/': {
      id: '/(authenticated)/$merchantId/stock-orders/$id/'
      path: '/$merchantId/stock-orders/$id'
      fullPath: '/$merchantId/stock-orders/$id'
      preLoaderRoute: typeof authenticatedMerchantIdStockOrdersIdPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/stock-orders/add/': {
      id: '/(authenticated)/$merchantId/stock-orders/add/'
      path: '/$merchantId/stock-orders/add'
      fullPath: '/$merchantId/stock-orders/add'
      preLoaderRoute: typeof authenticatedMerchantIdStockOrdersAddPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/transactions/batch/': {
      id: '/(authenticated)/$merchantId/transactions/batch/'
      path: '/$merchantId/transactions/batch'
      fullPath: '/$merchantId/transactions/batch'
      preLoaderRoute: typeof authenticatedMerchantIdTransactionsBatchPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(guest)/forgot-password/reset-password/$id/': {
      id: '/(guest)/forgot-password/reset-password/$id/'
      path: '/forgot-password/reset-password/$id'
      fullPath: '/forgot-password/reset-password/$id'
      preLoaderRoute: typeof guestForgotPasswordResetPasswordIdPageImport
      parentRoute: typeof guestLayoutImport
    }
    '/(authenticated)/$merchantId/invoices/$id/transaction/': {
      id: '/(authenticated)/$merchantId/invoices/$id/transaction/'
      path: '/$merchantId/invoices/$id/transaction'
      fullPath: '/$merchantId/invoices/$id/transaction'
      preLoaderRoute: typeof authenticatedMerchantIdInvoicesIdTransactionPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/merchant-defined-fields/$id/edit/': {
      id: '/(authenticated)/$merchantId/merchant-defined-fields/$id/edit/'
      path: '/$merchantId/merchant-defined-fields/$id/edit'
      fullPath: '/$merchantId/merchant-defined-fields/$id/edit'
      preLoaderRoute: typeof authenticatedMerchantIdMerchantDefinedFieldsIdEditPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/merchant-defined-fields/$id/preview/': {
      id: '/(authenticated)/$merchantId/merchant-defined-fields/$id/preview/'
      path: '/$merchantId/merchant-defined-fields/$id/preview'
      fullPath: '/$merchantId/merchant-defined-fields/$id/preview'
      preLoaderRoute: typeof authenticatedMerchantIdMerchantDefinedFieldsIdPreviewPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
    '/(authenticated)/$merchantId/transactions/$tab/$id/': {
      id: '/(authenticated)/$merchantId/transactions/$tab/$id/'
      path: '/$merchantId/transactions/$tab/$id'
      fullPath: '/$merchantId/transactions/$tab/$id'
      preLoaderRoute: typeof authenticatedMerchantIdTransactionsTabIdPageImport
      parentRoute: typeof authenticatedLayoutImport
    }
  }
}

// Create and export the route tree

interface authenticatedMerchantIdCustomersIdLayoutRouteChildren {
  authenticatedMerchantIdCustomersIdPageRoute: typeof authenticatedMerchantIdCustomersIdPageRoute
}

const authenticatedMerchantIdCustomersIdLayoutRouteChildren: authenticatedMerchantIdCustomersIdLayoutRouteChildren =
  {
    authenticatedMerchantIdCustomersIdPageRoute:
      authenticatedMerchantIdCustomersIdPageRoute,
  }

const authenticatedMerchantIdCustomersIdLayoutRouteWithChildren =
  authenticatedMerchantIdCustomersIdLayoutRoute._addFileChildren(
    authenticatedMerchantIdCustomersIdLayoutRouteChildren,
  )

interface authenticatedLayoutRouteChildren {
  authenticatedPageRoute: typeof authenticatedPageRoute
  authenticatedMerchantIdCustomersIdLayoutRoute: typeof authenticatedMerchantIdCustomersIdLayoutRouteWithChildren
  authenticatedMerchantIdCategoriesPageRoute: typeof authenticatedMerchantIdCategoriesPageRoute
  authenticatedMerchantIdCustomersPageRoute: typeof authenticatedMerchantIdCustomersPageRoute
  authenticatedMerchantIdInvoicesPageRoute: typeof authenticatedMerchantIdInvoicesPageRoute
  authenticatedMerchantIdLocationsPageRoute: typeof authenticatedMerchantIdLocationsPageRoute
  authenticatedMerchantIdMerchantDefinedFieldsPageRoute: typeof authenticatedMerchantIdMerchantDefinedFieldsPageRoute
  authenticatedMerchantIdPackagesPageRoute: typeof authenticatedMerchantIdPackagesPageRoute
  authenticatedMerchantIdPlansPageRoute: typeof authenticatedMerchantIdPlansPageRoute
  authenticatedMerchantIdProductsPageRoute: typeof authenticatedMerchantIdProductsPageRoute
  authenticatedMerchantIdRecursPageRoute: typeof authenticatedMerchantIdRecursPageRoute
  authenticatedMerchantIdStockOrdersPageRoute: typeof authenticatedMerchantIdStockOrdersPageRoute
  authenticatedMerchantIdTransactionsPageRoute: typeof authenticatedMerchantIdTransactionsPageRoute
  authenticatedMerchantIdVirtualTerminalPageRoute: typeof authenticatedMerchantIdVirtualTerminalPageRoute
  authenticatedSettingAccountPageRoute: typeof authenticatedSettingAccountPageRoute
  authenticatedSettingMfaPageRoute: typeof authenticatedSettingMfaPageRoute
  authenticatedMerchantIdCustomersAddPageRoute: typeof authenticatedMerchantIdCustomersAddPageRoute
  authenticatedMerchantIdInvoicesIdPageRoute: typeof authenticatedMerchantIdInvoicesIdPageRoute
  authenticatedMerchantIdInvoicesAddPageRoute: typeof authenticatedMerchantIdInvoicesAddPageRoute
  authenticatedMerchantIdMerchantDefinedFieldsAddPageRoute: typeof authenticatedMerchantIdMerchantDefinedFieldsAddPageRoute
  authenticatedMerchantIdPackagesIdPageRoute: typeof authenticatedMerchantIdPackagesIdPageRoute
  authenticatedMerchantIdPackagesAddPageRoute: typeof authenticatedMerchantIdPackagesAddPageRoute
  authenticatedMerchantIdPlansIdPageRoute: typeof authenticatedMerchantIdPlansIdPageRoute
  authenticatedMerchantIdPlansAddPageRoute: typeof authenticatedMerchantIdPlansAddPageRoute
  authenticatedMerchantIdProductsIdPageRoute: typeof authenticatedMerchantIdProductsIdPageRoute
  authenticatedMerchantIdProductsAddPageRoute: typeof authenticatedMerchantIdProductsAddPageRoute
  authenticatedMerchantIdRecursIdPageRoute: typeof authenticatedMerchantIdRecursIdPageRoute
  authenticatedMerchantIdRecursAddPageRoute: typeof authenticatedMerchantIdRecursAddPageRoute
  authenticatedMerchantIdStockOrdersIdPageRoute: typeof authenticatedMerchantIdStockOrdersIdPageRoute
  authenticatedMerchantIdStockOrdersAddPageRoute: typeof authenticatedMerchantIdStockOrdersAddPageRoute
  authenticatedMerchantIdTransactionsBatchPageRoute: typeof authenticatedMerchantIdTransactionsBatchPageRoute
  authenticatedMerchantIdInvoicesIdTransactionPageRoute: typeof authenticatedMerchantIdInvoicesIdTransactionPageRoute
  authenticatedMerchantIdMerchantDefinedFieldsIdEditPageRoute: typeof authenticatedMerchantIdMerchantDefinedFieldsIdEditPageRoute
  authenticatedMerchantIdMerchantDefinedFieldsIdPreviewPageRoute: typeof authenticatedMerchantIdMerchantDefinedFieldsIdPreviewPageRoute
  authenticatedMerchantIdTransactionsTabIdPageRoute: typeof authenticatedMerchantIdTransactionsTabIdPageRoute
}

const authenticatedLayoutRouteChildren: authenticatedLayoutRouteChildren = {
  authenticatedPageRoute: authenticatedPageRoute,
  authenticatedMerchantIdCustomersIdLayoutRoute:
    authenticatedMerchantIdCustomersIdLayoutRouteWithChildren,
  authenticatedMerchantIdCategoriesPageRoute:
    authenticatedMerchantIdCategoriesPageRoute,
  authenticatedMerchantIdCustomersPageRoute:
    authenticatedMerchantIdCustomersPageRoute,
  authenticatedMerchantIdInvoicesPageRoute:
    authenticatedMerchantIdInvoicesPageRoute,
  authenticatedMerchantIdLocationsPageRoute:
    authenticatedMerchantIdLocationsPageRoute,
  authenticatedMerchantIdMerchantDefinedFieldsPageRoute:
    authenticatedMerchantIdMerchantDefinedFieldsPageRoute,
  authenticatedMerchantIdPackagesPageRoute:
    authenticatedMerchantIdPackagesPageRoute,
  authenticatedMerchantIdPlansPageRoute: authenticatedMerchantIdPlansPageRoute,
  authenticatedMerchantIdProductsPageRoute:
    authenticatedMerchantIdProductsPageRoute,
  authenticatedMerchantIdRecursPageRoute:
    authenticatedMerchantIdRecursPageRoute,
  authenticatedMerchantIdStockOrdersPageRoute:
    authenticatedMerchantIdStockOrdersPageRoute,
  authenticatedMerchantIdTransactionsPageRoute:
    authenticatedMerchantIdTransactionsPageRoute,
  authenticatedMerchantIdVirtualTerminalPageRoute:
    authenticatedMerchantIdVirtualTerminalPageRoute,
  authenticatedSettingAccountPageRoute: authenticatedSettingAccountPageRoute,
  authenticatedSettingMfaPageRoute: authenticatedSettingMfaPageRoute,
  authenticatedMerchantIdCustomersAddPageRoute:
    authenticatedMerchantIdCustomersAddPageRoute,
  authenticatedMerchantIdInvoicesIdPageRoute:
    authenticatedMerchantIdInvoicesIdPageRoute,
  authenticatedMerchantIdInvoicesAddPageRoute:
    authenticatedMerchantIdInvoicesAddPageRoute,
  authenticatedMerchantIdMerchantDefinedFieldsAddPageRoute:
    authenticatedMerchantIdMerchantDefinedFieldsAddPageRoute,
  authenticatedMerchantIdPackagesIdPageRoute:
    authenticatedMerchantIdPackagesIdPageRoute,
  authenticatedMerchantIdPackagesAddPageRoute:
    authenticatedMerchantIdPackagesAddPageRoute,
  authenticatedMerchantIdPlansIdPageRoute:
    authenticatedMerchantIdPlansIdPageRoute,
  authenticatedMerchantIdPlansAddPageRoute:
    authenticatedMerchantIdPlansAddPageRoute,
  authenticatedMerchantIdProductsIdPageRoute:
    authenticatedMerchantIdProductsIdPageRoute,
  authenticatedMerchantIdProductsAddPageRoute:
    authenticatedMerchantIdProductsAddPageRoute,
  authenticatedMerchantIdRecursIdPageRoute:
    authenticatedMerchantIdRecursIdPageRoute,
  authenticatedMerchantIdRecursAddPageRoute:
    authenticatedMerchantIdRecursAddPageRoute,
  authenticatedMerchantIdStockOrdersIdPageRoute:
    authenticatedMerchantIdStockOrdersIdPageRoute,
  authenticatedMerchantIdStockOrdersAddPageRoute:
    authenticatedMerchantIdStockOrdersAddPageRoute,
  authenticatedMerchantIdTransactionsBatchPageRoute:
    authenticatedMerchantIdTransactionsBatchPageRoute,
  authenticatedMerchantIdInvoicesIdTransactionPageRoute:
    authenticatedMerchantIdInvoicesIdTransactionPageRoute,
  authenticatedMerchantIdMerchantDefinedFieldsIdEditPageRoute:
    authenticatedMerchantIdMerchantDefinedFieldsIdEditPageRoute,
  authenticatedMerchantIdMerchantDefinedFieldsIdPreviewPageRoute:
    authenticatedMerchantIdMerchantDefinedFieldsIdPreviewPageRoute,
  authenticatedMerchantIdTransactionsTabIdPageRoute:
    authenticatedMerchantIdTransactionsTabIdPageRoute,
}

const authenticatedLayoutRouteWithChildren =
  authenticatedLayoutRoute._addFileChildren(authenticatedLayoutRouteChildren)

interface guestLayoutRouteChildren {
  guestForgotPasswordPageRoute: typeof guestForgotPasswordPageRoute
  guestLoginPageRoute: typeof guestLoginPageRoute
  guestSettingMfaPageRoute: typeof guestSettingMfaPageRoute
  guestTwoFactorPageRoute: typeof guestTwoFactorPageRoute
  guestForgotPasswordResetPasswordIdPageRoute: typeof guestForgotPasswordResetPasswordIdPageRoute
}

const guestLayoutRouteChildren: guestLayoutRouteChildren = {
  guestForgotPasswordPageRoute: guestForgotPasswordPageRoute,
  guestLoginPageRoute: guestLoginPageRoute,
  guestSettingMfaPageRoute: guestSettingMfaPageRoute,
  guestTwoFactorPageRoute: guestTwoFactorPageRoute,
  guestForgotPasswordResetPasswordIdPageRoute:
    guestForgotPasswordResetPasswordIdPageRoute,
}

const guestLayoutRouteWithChildren = guestLayoutRoute._addFileChildren(
  guestLayoutRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof authenticatedPageRoute
  '/*': typeof Route
  '/forgot-password': typeof guestForgotPasswordPageRoute
  '/login': typeof guestLoginPageRoute
  '/setting-mfa': typeof guestSettingMfaPageRoute
  '/two-factor': typeof guestTwoFactorPageRoute
  '/$merchantId/customers/$id': typeof authenticatedMerchantIdCustomersIdLayoutRouteWithChildren
  '/$merchantId/categories': typeof authenticatedMerchantIdCategoriesPageRoute
  '/$merchantId/customers': typeof authenticatedMerchantIdCustomersPageRoute
  '/$merchantId/invoices': typeof authenticatedMerchantIdInvoicesPageRoute
  '/$merchantId/locations': typeof authenticatedMerchantIdLocationsPageRoute
  '/$merchantId/merchant-defined-fields': typeof authenticatedMerchantIdMerchantDefinedFieldsPageRoute
  '/$merchantId/packages': typeof authenticatedMerchantIdPackagesPageRoute
  '/$merchantId/plans': typeof authenticatedMerchantIdPlansPageRoute
  '/$merchantId/products': typeof authenticatedMerchantIdProductsPageRoute
  '/$merchantId/recurs': typeof authenticatedMerchantIdRecursPageRoute
  '/$merchantId/stock-orders': typeof authenticatedMerchantIdStockOrdersPageRoute
  '/$merchantId/transactions': typeof authenticatedMerchantIdTransactionsPageRoute
  '/$merchantId/virtual-terminal': typeof authenticatedMerchantIdVirtualTerminalPageRoute
  '/setting/account': typeof authenticatedSettingAccountPageRoute
  '/setting/mfa': typeof authenticatedSettingMfaPageRoute
  '/$merchantId/customers/$id/': typeof authenticatedMerchantIdCustomersIdPageRoute
  '/$merchantId/customers/add': typeof authenticatedMerchantIdCustomersAddPageRoute
  '/$merchantId/invoices/$id': typeof authenticatedMerchantIdInvoicesIdPageRoute
  '/$merchantId/invoices/add': typeof authenticatedMerchantIdInvoicesAddPageRoute
  '/$merchantId/merchant-defined-fields/add': typeof authenticatedMerchantIdMerchantDefinedFieldsAddPageRoute
  '/$merchantId/packages/$id': typeof authenticatedMerchantIdPackagesIdPageRoute
  '/$merchantId/packages/add': typeof authenticatedMerchantIdPackagesAddPageRoute
  '/$merchantId/plans/$id': typeof authenticatedMerchantIdPlansIdPageRoute
  '/$merchantId/plans/add': typeof authenticatedMerchantIdPlansAddPageRoute
  '/$merchantId/products/$id': typeof authenticatedMerchantIdProductsIdPageRoute
  '/$merchantId/products/add': typeof authenticatedMerchantIdProductsAddPageRoute
  '/$merchantId/recurs/$id': typeof authenticatedMerchantIdRecursIdPageRoute
  '/$merchantId/recurs/add': typeof authenticatedMerchantIdRecursAddPageRoute
  '/$merchantId/stock-orders/$id': typeof authenticatedMerchantIdStockOrdersIdPageRoute
  '/$merchantId/stock-orders/add': typeof authenticatedMerchantIdStockOrdersAddPageRoute
  '/$merchantId/transactions/batch': typeof authenticatedMerchantIdTransactionsBatchPageRoute
  '/forgot-password/reset-password/$id': typeof guestForgotPasswordResetPasswordIdPageRoute
  '/$merchantId/invoices/$id/transaction': typeof authenticatedMerchantIdInvoicesIdTransactionPageRoute
  '/$merchantId/merchant-defined-fields/$id/edit': typeof authenticatedMerchantIdMerchantDefinedFieldsIdEditPageRoute
  '/$merchantId/merchant-defined-fields/$id/preview': typeof authenticatedMerchantIdMerchantDefinedFieldsIdPreviewPageRoute
  '/$merchantId/transactions/$tab/$id': typeof authenticatedMerchantIdTransactionsTabIdPageRoute
}

export interface FileRoutesByTo {
  '/': typeof authenticatedPageRoute
  '/*': typeof Route
  '/forgot-password': typeof guestForgotPasswordPageRoute
  '/login': typeof guestLoginPageRoute
  '/setting-mfa': typeof guestSettingMfaPageRoute
  '/two-factor': typeof guestTwoFactorPageRoute
  '/$merchantId/categories': typeof authenticatedMerchantIdCategoriesPageRoute
  '/$merchantId/customers': typeof authenticatedMerchantIdCustomersPageRoute
  '/$merchantId/invoices': typeof authenticatedMerchantIdInvoicesPageRoute
  '/$merchantId/locations': typeof authenticatedMerchantIdLocationsPageRoute
  '/$merchantId/merchant-defined-fields': typeof authenticatedMerchantIdMerchantDefinedFieldsPageRoute
  '/$merchantId/packages': typeof authenticatedMerchantIdPackagesPageRoute
  '/$merchantId/plans': typeof authenticatedMerchantIdPlansPageRoute
  '/$merchantId/products': typeof authenticatedMerchantIdProductsPageRoute
  '/$merchantId/recurs': typeof authenticatedMerchantIdRecursPageRoute
  '/$merchantId/stock-orders': typeof authenticatedMerchantIdStockOrdersPageRoute
  '/$merchantId/transactions': typeof authenticatedMerchantIdTransactionsPageRoute
  '/$merchantId/virtual-terminal': typeof authenticatedMerchantIdVirtualTerminalPageRoute
  '/setting/account': typeof authenticatedSettingAccountPageRoute
  '/setting/mfa': typeof authenticatedSettingMfaPageRoute
  '/$merchantId/customers/$id': typeof authenticatedMerchantIdCustomersIdPageRoute
  '/$merchantId/customers/add': typeof authenticatedMerchantIdCustomersAddPageRoute
  '/$merchantId/invoices/$id': typeof authenticatedMerchantIdInvoicesIdPageRoute
  '/$merchantId/invoices/add': typeof authenticatedMerchantIdInvoicesAddPageRoute
  '/$merchantId/merchant-defined-fields/add': typeof authenticatedMerchantIdMerchantDefinedFieldsAddPageRoute
  '/$merchantId/packages/$id': typeof authenticatedMerchantIdPackagesIdPageRoute
  '/$merchantId/packages/add': typeof authenticatedMerchantIdPackagesAddPageRoute
  '/$merchantId/plans/$id': typeof authenticatedMerchantIdPlansIdPageRoute
  '/$merchantId/plans/add': typeof authenticatedMerchantIdPlansAddPageRoute
  '/$merchantId/products/$id': typeof authenticatedMerchantIdProductsIdPageRoute
  '/$merchantId/products/add': typeof authenticatedMerchantIdProductsAddPageRoute
  '/$merchantId/recurs/$id': typeof authenticatedMerchantIdRecursIdPageRoute
  '/$merchantId/recurs/add': typeof authenticatedMerchantIdRecursAddPageRoute
  '/$merchantId/stock-orders/$id': typeof authenticatedMerchantIdStockOrdersIdPageRoute
  '/$merchantId/stock-orders/add': typeof authenticatedMerchantIdStockOrdersAddPageRoute
  '/$merchantId/transactions/batch': typeof authenticatedMerchantIdTransactionsBatchPageRoute
  '/forgot-password/reset-password/$id': typeof guestForgotPasswordResetPasswordIdPageRoute
  '/$merchantId/invoices/$id/transaction': typeof authenticatedMerchantIdInvoicesIdTransactionPageRoute
  '/$merchantId/merchant-defined-fields/$id/edit': typeof authenticatedMerchantIdMerchantDefinedFieldsIdEditPageRoute
  '/$merchantId/merchant-defined-fields/$id/preview': typeof authenticatedMerchantIdMerchantDefinedFieldsIdPreviewPageRoute
  '/$merchantId/transactions/$tab/$id': typeof authenticatedMerchantIdTransactionsTabIdPageRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/(authenticated)': typeof authenticatedLayoutRouteWithChildren
  '/(guest)': typeof guestLayoutRouteWithChildren
  '/*': typeof Route
  '/(authenticated)/': typeof authenticatedPageRoute
  '/(guest)/forgot-password/': typeof guestForgotPasswordPageRoute
  '/(guest)/login/': typeof guestLoginPageRoute
  '/(guest)/setting-mfa/': typeof guestSettingMfaPageRoute
  '/(guest)/two-factor/': typeof guestTwoFactorPageRoute
  '/(authenticated)/$merchantId/customers/$id': typeof authenticatedMerchantIdCustomersIdLayoutRouteWithChildren
  '/(authenticated)/$merchantId/categories/': typeof authenticatedMerchantIdCategoriesPageRoute
  '/(authenticated)/$merchantId/customers/': typeof authenticatedMerchantIdCustomersPageRoute
  '/(authenticated)/$merchantId/invoices/': typeof authenticatedMerchantIdInvoicesPageRoute
  '/(authenticated)/$merchantId/locations/': typeof authenticatedMerchantIdLocationsPageRoute
  '/(authenticated)/$merchantId/merchant-defined-fields/': typeof authenticatedMerchantIdMerchantDefinedFieldsPageRoute
  '/(authenticated)/$merchantId/packages/': typeof authenticatedMerchantIdPackagesPageRoute
  '/(authenticated)/$merchantId/plans/': typeof authenticatedMerchantIdPlansPageRoute
  '/(authenticated)/$merchantId/products/': typeof authenticatedMerchantIdProductsPageRoute
  '/(authenticated)/$merchantId/recurs/': typeof authenticatedMerchantIdRecursPageRoute
  '/(authenticated)/$merchantId/stock-orders/': typeof authenticatedMerchantIdStockOrdersPageRoute
  '/(authenticated)/$merchantId/transactions/': typeof authenticatedMerchantIdTransactionsPageRoute
  '/(authenticated)/$merchantId/virtual-terminal/': typeof authenticatedMerchantIdVirtualTerminalPageRoute
  '/(authenticated)/setting/account/': typeof authenticatedSettingAccountPageRoute
  '/(authenticated)/setting/mfa/': typeof authenticatedSettingMfaPageRoute
  '/(authenticated)/$merchantId/customers/$id/': typeof authenticatedMerchantIdCustomersIdPageRoute
  '/(authenticated)/$merchantId/customers/add/': typeof authenticatedMerchantIdCustomersAddPageRoute
  '/(authenticated)/$merchantId/invoices/$id/': typeof authenticatedMerchantIdInvoicesIdPageRoute
  '/(authenticated)/$merchantId/invoices/add/': typeof authenticatedMerchantIdInvoicesAddPageRoute
  '/(authenticated)/$merchantId/merchant-defined-fields/add/': typeof authenticatedMerchantIdMerchantDefinedFieldsAddPageRoute
  '/(authenticated)/$merchantId/packages/$id/': typeof authenticatedMerchantIdPackagesIdPageRoute
  '/(authenticated)/$merchantId/packages/add/': typeof authenticatedMerchantIdPackagesAddPageRoute
  '/(authenticated)/$merchantId/plans/$id/': typeof authenticatedMerchantIdPlansIdPageRoute
  '/(authenticated)/$merchantId/plans/add/': typeof authenticatedMerchantIdPlansAddPageRoute
  '/(authenticated)/$merchantId/products/$id/': typeof authenticatedMerchantIdProductsIdPageRoute
  '/(authenticated)/$merchantId/products/add/': typeof authenticatedMerchantIdProductsAddPageRoute
  '/(authenticated)/$merchantId/recurs/$id/': typeof authenticatedMerchantIdRecursIdPageRoute
  '/(authenticated)/$merchantId/recurs/add/': typeof authenticatedMerchantIdRecursAddPageRoute
  '/(authenticated)/$merchantId/stock-orders/$id/': typeof authenticatedMerchantIdStockOrdersIdPageRoute
  '/(authenticated)/$merchantId/stock-orders/add/': typeof authenticatedMerchantIdStockOrdersAddPageRoute
  '/(authenticated)/$merchantId/transactions/batch/': typeof authenticatedMerchantIdTransactionsBatchPageRoute
  '/(guest)/forgot-password/reset-password/$id/': typeof guestForgotPasswordResetPasswordIdPageRoute
  '/(authenticated)/$merchantId/invoices/$id/transaction/': typeof authenticatedMerchantIdInvoicesIdTransactionPageRoute
  '/(authenticated)/$merchantId/merchant-defined-fields/$id/edit/': typeof authenticatedMerchantIdMerchantDefinedFieldsIdEditPageRoute
  '/(authenticated)/$merchantId/merchant-defined-fields/$id/preview/': typeof authenticatedMerchantIdMerchantDefinedFieldsIdPreviewPageRoute
  '/(authenticated)/$merchantId/transactions/$tab/$id/': typeof authenticatedMerchantIdTransactionsTabIdPageRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/*'
    | '/forgot-password'
    | '/login'
    | '/setting-mfa'
    | '/two-factor'
    | '/$merchantId/customers/$id'
    | '/$merchantId/categories'
    | '/$merchantId/customers'
    | '/$merchantId/invoices'
    | '/$merchantId/locations'
    | '/$merchantId/merchant-defined-fields'
    | '/$merchantId/packages'
    | '/$merchantId/plans'
    | '/$merchantId/products'
    | '/$merchantId/recurs'
    | '/$merchantId/stock-orders'
    | '/$merchantId/transactions'
    | '/$merchantId/virtual-terminal'
    | '/setting/account'
    | '/setting/mfa'
    | '/$merchantId/customers/$id/'
    | '/$merchantId/customers/add'
    | '/$merchantId/invoices/$id'
    | '/$merchantId/invoices/add'
    | '/$merchantId/merchant-defined-fields/add'
    | '/$merchantId/packages/$id'
    | '/$merchantId/packages/add'
    | '/$merchantId/plans/$id'
    | '/$merchantId/plans/add'
    | '/$merchantId/products/$id'
    | '/$merchantId/products/add'
    | '/$merchantId/recurs/$id'
    | '/$merchantId/recurs/add'
    | '/$merchantId/stock-orders/$id'
    | '/$merchantId/stock-orders/add'
    | '/$merchantId/transactions/batch'
    | '/forgot-password/reset-password/$id'
    | '/$merchantId/invoices/$id/transaction'
    | '/$merchantId/merchant-defined-fields/$id/edit'
    | '/$merchantId/merchant-defined-fields/$id/preview'
    | '/$merchantId/transactions/$tab/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/*'
    | '/forgot-password'
    | '/login'
    | '/setting-mfa'
    | '/two-factor'
    | '/$merchantId/categories'
    | '/$merchantId/customers'
    | '/$merchantId/invoices'
    | '/$merchantId/locations'
    | '/$merchantId/merchant-defined-fields'
    | '/$merchantId/packages'
    | '/$merchantId/plans'
    | '/$merchantId/products'
    | '/$merchantId/recurs'
    | '/$merchantId/stock-orders'
    | '/$merchantId/transactions'
    | '/$merchantId/virtual-terminal'
    | '/setting/account'
    | '/setting/mfa'
    | '/$merchantId/customers/$id'
    | '/$merchantId/customers/add'
    | '/$merchantId/invoices/$id'
    | '/$merchantId/invoices/add'
    | '/$merchantId/merchant-defined-fields/add'
    | '/$merchantId/packages/$id'
    | '/$merchantId/packages/add'
    | '/$merchantId/plans/$id'
    | '/$merchantId/plans/add'
    | '/$merchantId/products/$id'
    | '/$merchantId/products/add'
    | '/$merchantId/recurs/$id'
    | '/$merchantId/recurs/add'
    | '/$merchantId/stock-orders/$id'
    | '/$merchantId/stock-orders/add'
    | '/$merchantId/transactions/batch'
    | '/forgot-password/reset-password/$id'
    | '/$merchantId/invoices/$id/transaction'
    | '/$merchantId/merchant-defined-fields/$id/edit'
    | '/$merchantId/merchant-defined-fields/$id/preview'
    | '/$merchantId/transactions/$tab/$id'
  id:
    | '__root__'
    | '/(authenticated)'
    | '/(guest)'
    | '/*'
    | '/(authenticated)/'
    | '/(guest)/forgot-password/'
    | '/(guest)/login/'
    | '/(guest)/setting-mfa/'
    | '/(guest)/two-factor/'
    | '/(authenticated)/$merchantId/customers/$id'
    | '/(authenticated)/$merchantId/categories/'
    | '/(authenticated)/$merchantId/customers/'
    | '/(authenticated)/$merchantId/invoices/'
    | '/(authenticated)/$merchantId/locations/'
    | '/(authenticated)/$merchantId/merchant-defined-fields/'
    | '/(authenticated)/$merchantId/packages/'
    | '/(authenticated)/$merchantId/plans/'
    | '/(authenticated)/$merchantId/products/'
    | '/(authenticated)/$merchantId/recurs/'
    | '/(authenticated)/$merchantId/stock-orders/'
    | '/(authenticated)/$merchantId/transactions/'
    | '/(authenticated)/$merchantId/virtual-terminal/'
    | '/(authenticated)/setting/account/'
    | '/(authenticated)/setting/mfa/'
    | '/(authenticated)/$merchantId/customers/$id/'
    | '/(authenticated)/$merchantId/customers/add/'
    | '/(authenticated)/$merchantId/invoices/$id/'
    | '/(authenticated)/$merchantId/invoices/add/'
    | '/(authenticated)/$merchantId/merchant-defined-fields/add/'
    | '/(authenticated)/$merchantId/packages/$id/'
    | '/(authenticated)/$merchantId/packages/add/'
    | '/(authenticated)/$merchantId/plans/$id/'
    | '/(authenticated)/$merchantId/plans/add/'
    | '/(authenticated)/$merchantId/products/$id/'
    | '/(authenticated)/$merchantId/products/add/'
    | '/(authenticated)/$merchantId/recurs/$id/'
    | '/(authenticated)/$merchantId/recurs/add/'
    | '/(authenticated)/$merchantId/stock-orders/$id/'
    | '/(authenticated)/$merchantId/stock-orders/add/'
    | '/(authenticated)/$merchantId/transactions/batch/'
    | '/(guest)/forgot-password/reset-password/$id/'
    | '/(authenticated)/$merchantId/invoices/$id/transaction/'
    | '/(authenticated)/$merchantId/merchant-defined-fields/$id/edit/'
    | '/(authenticated)/$merchantId/merchant-defined-fields/$id/preview/'
    | '/(authenticated)/$merchantId/transactions/$tab/$id/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  authenticatedLayoutRoute: typeof authenticatedLayoutRouteWithChildren
  guestLayoutRoute: typeof guestLayoutRouteWithChildren
  Route: typeof Route
}

const rootRouteChildren: RootRouteChildren = {
  authenticatedLayoutRoute: authenticatedLayoutRouteWithChildren,
  guestLayoutRoute: guestLayoutRouteWithChildren,
  Route: Route,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/(authenticated)",
        "/(guest)",
        "/*"
      ]
    },
    "/(authenticated)": {
      "filePath": "(authenticated)/layout.tsx",
      "children": [
        "/(authenticated)/",
        "/(authenticated)/$merchantId/customers/$id",
        "/(authenticated)/$merchantId/categories/",
        "/(authenticated)/$merchantId/customers/",
        "/(authenticated)/$merchantId/invoices/",
        "/(authenticated)/$merchantId/locations/",
        "/(authenticated)/$merchantId/merchant-defined-fields/",
        "/(authenticated)/$merchantId/packages/",
        "/(authenticated)/$merchantId/plans/",
        "/(authenticated)/$merchantId/products/",
        "/(authenticated)/$merchantId/recurs/",
        "/(authenticated)/$merchantId/stock-orders/",
        "/(authenticated)/$merchantId/transactions/",
        "/(authenticated)/$merchantId/virtual-terminal/",
        "/(authenticated)/setting/account/",
        "/(authenticated)/setting/mfa/",
        "/(authenticated)/$merchantId/customers/add/",
        "/(authenticated)/$merchantId/invoices/$id/",
        "/(authenticated)/$merchantId/invoices/add/",
        "/(authenticated)/$merchantId/merchant-defined-fields/add/",
        "/(authenticated)/$merchantId/packages/$id/",
        "/(authenticated)/$merchantId/packages/add/",
        "/(authenticated)/$merchantId/plans/$id/",
        "/(authenticated)/$merchantId/plans/add/",
        "/(authenticated)/$merchantId/products/$id/",
        "/(authenticated)/$merchantId/products/add/",
        "/(authenticated)/$merchantId/recurs/$id/",
        "/(authenticated)/$merchantId/recurs/add/",
        "/(authenticated)/$merchantId/stock-orders/$id/",
        "/(authenticated)/$merchantId/stock-orders/add/",
        "/(authenticated)/$merchantId/transactions/batch/",
        "/(authenticated)/$merchantId/invoices/$id/transaction/",
        "/(authenticated)/$merchantId/merchant-defined-fields/$id/edit/",
        "/(authenticated)/$merchantId/merchant-defined-fields/$id/preview/",
        "/(authenticated)/$merchantId/transactions/$tab/$id/"
      ]
    },
    "/(guest)": {
      "filePath": "(guest)/layout.tsx",
      "children": [
        "/(guest)/forgot-password/",
        "/(guest)/login/",
        "/(guest)/setting-mfa/",
        "/(guest)/two-factor/",
        "/(guest)/forgot-password/reset-password/$id/"
      ]
    },
    "/*": {
      "filePath": "*.tsx"
    },
    "/(authenticated)/": {
      "filePath": "(authenticated)/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(guest)/forgot-password/": {
      "filePath": "(guest)/forgot-password/page.tsx",
      "parent": "/(guest)"
    },
    "/(guest)/login/": {
      "filePath": "(guest)/login/page.tsx",
      "parent": "/(guest)"
    },
    "/(guest)/setting-mfa/": {
      "filePath": "(guest)/setting-mfa/page.tsx",
      "parent": "/(guest)"
    },
    "/(guest)/two-factor/": {
      "filePath": "(guest)/two-factor/page.tsx",
      "parent": "/(guest)"
    },
    "/(authenticated)/$merchantId/customers/$id": {
      "filePath": "(authenticated)/$merchantId/customers/$id/layout.tsx",
      "parent": "/(authenticated)",
      "children": [
        "/(authenticated)/$merchantId/customers/$id/"
      ]
    },
    "/(authenticated)/$merchantId/categories/": {
      "filePath": "(authenticated)/$merchantId/categories/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/customers/": {
      "filePath": "(authenticated)/$merchantId/customers/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/invoices/": {
      "filePath": "(authenticated)/$merchantId/invoices/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/locations/": {
      "filePath": "(authenticated)/$merchantId/locations/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/merchant-defined-fields/": {
      "filePath": "(authenticated)/$merchantId/merchant-defined-fields/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/packages/": {
      "filePath": "(authenticated)/$merchantId/packages/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/plans/": {
      "filePath": "(authenticated)/$merchantId/plans/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/products/": {
      "filePath": "(authenticated)/$merchantId/products/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/recurs/": {
      "filePath": "(authenticated)/$merchantId/recurs/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/stock-orders/": {
      "filePath": "(authenticated)/$merchantId/stock-orders/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/transactions/": {
      "filePath": "(authenticated)/$merchantId/transactions/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/virtual-terminal/": {
      "filePath": "(authenticated)/$merchantId/virtual-terminal/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/setting/account/": {
      "filePath": "(authenticated)/setting/account/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/setting/mfa/": {
      "filePath": "(authenticated)/setting/mfa/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/customers/$id/": {
      "filePath": "(authenticated)/$merchantId/customers/$id/page.tsx",
      "parent": "/(authenticated)/$merchantId/customers/$id"
    },
    "/(authenticated)/$merchantId/customers/add/": {
      "filePath": "(authenticated)/$merchantId/customers/add/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/invoices/$id/": {
      "filePath": "(authenticated)/$merchantId/invoices/$id/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/invoices/add/": {
      "filePath": "(authenticated)/$merchantId/invoices/add/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/merchant-defined-fields/add/": {
      "filePath": "(authenticated)/$merchantId/merchant-defined-fields/add/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/packages/$id/": {
      "filePath": "(authenticated)/$merchantId/packages/$id/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/packages/add/": {
      "filePath": "(authenticated)/$merchantId/packages/add/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/plans/$id/": {
      "filePath": "(authenticated)/$merchantId/plans/$id/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/plans/add/": {
      "filePath": "(authenticated)/$merchantId/plans/add/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/products/$id/": {
      "filePath": "(authenticated)/$merchantId/products/$id/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/products/add/": {
      "filePath": "(authenticated)/$merchantId/products/add/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/recurs/$id/": {
      "filePath": "(authenticated)/$merchantId/recurs/$id/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/recurs/add/": {
      "filePath": "(authenticated)/$merchantId/recurs/add/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/stock-orders/$id/": {
      "filePath": "(authenticated)/$merchantId/stock-orders/$id/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/stock-orders/add/": {
      "filePath": "(authenticated)/$merchantId/stock-orders/add/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/transactions/batch/": {
      "filePath": "(authenticated)/$merchantId/transactions/batch/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(guest)/forgot-password/reset-password/$id/": {
      "filePath": "(guest)/forgot-password/reset-password/$id/page.tsx",
      "parent": "/(guest)"
    },
    "/(authenticated)/$merchantId/invoices/$id/transaction/": {
      "filePath": "(authenticated)/$merchantId/invoices/$id/transaction/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/merchant-defined-fields/$id/edit/": {
      "filePath": "(authenticated)/$merchantId/merchant-defined-fields/$id/edit/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/merchant-defined-fields/$id/preview/": {
      "filePath": "(authenticated)/$merchantId/merchant-defined-fields/$id/preview/page.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/$merchantId/transactions/$tab/$id/": {
      "filePath": "(authenticated)/$merchantId/transactions/$tab/$id/page.tsx",
      "parent": "/(authenticated)"
    }
  }
}
ROUTE_MANIFEST_END */
